import { getIntlLocale } from "@/shared/lib/i18n/config"

type BlogDateFormat = "long" | "medium" | "monthDay"

export function formatBlogDate(
  dateString: string,
  format: BlogDateFormat = "long",
  locale: string = "en-US"
): string {
  const options: Intl.DateTimeFormatOptions =
    format === "long"
      ? { year: "numeric", month: "long", day: "numeric", timeZone: "UTC" }
      : format === "medium"
        ? { year: "numeric", month: "short", day: "numeric", timeZone: "UTC" }
        : { month: "long", day: "numeric", timeZone: "UTC" }

  return new Date(dateString).toLocaleDateString(getIntlLocale(locale), options)
}
